import { Alert, styled } from '@shared/components';

const BaseAlert = styled(Alert)(({ theme, action }) => ({
  padding: theme.spacing(action ? 2 : 3, 4),
  width: '100%',
  '& .MuiAlert-action': {
    marginRight: theme.spacing(0),
  },
}));

export default BaseAlert;
